"use client";
import { useState, useEffect } from "react";
import { useJobFilterStore } from "../../store/useJobFilterStore";
import PhoneInput from "react-phone-number-input";

import "react-phone-number-input/style.css";

type Props = {
  initialData: {
    name: string;
    phoneNumber: string;
    industry: string;
    size: string;
    website: string;
    logo: string;
  };
  onChange: (data: {
    name: string;
    phone: string;
    industry_id: string;
    company_size_id: string;
    website: string;
    logo?: File | null;
    isValid: boolean;
  }) => void;
};


export default function EditCompanyForm({ initialData, onChange }: Props) {
  const [form, setForm] = useState({
    name: initialData.name ?? "",
    phone: initialData.phoneNumber ?? "",
    industry_id: initialData.industry ?? "",
    company_size_id: initialData.size ?? "",
    website: initialData.website ?? "",
  });

  const [logoPreview, setLogoPreview] = useState(initialData.logo);

  const { industries, sizes, fetchFilters } = useJobFilterStore();

  const urlToFile = async (url: string): Promise<File> => {
    const res = await fetch(url);
    const blob = await res.blob();
    return new File([blob], "logo.jpg", { type: blob.type });
  };

  const [logoFile, setLogoFile] = useState<File | null>(null);

  useEffect(() => {
    if (!initialData.logo) return;

    urlToFile(initialData.logo).then((file) => {
      setLogoFile(file);
    });
  }, [initialData.logo]);


  useEffect(() => {
    fetchFilters("en");
  }, []);

  // ⬅️ kirim data ke parent setiap berubah
  useEffect(() => {
    const isValid =
      form.name.trim() !== "" &&
      form.industry_id !== "" &&
      form.company_size_id !== "";

    onChange({
      name: form.name,
      phone: form.phone,
      industry_id: form.industry_id,
      company_size_id: form.company_size_id,
      website: form.website,
      logo: logoFile, // boleh null
      isValid,
    });
  }, [form, logoFile]);


  const handlePhoneChange = (value?: string) => {
    setForm((prev) => ({
      ...prev,
      phone: value || "",
    }));
  };


  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleLogoUpload = (e: any) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setLogoPreview(URL.createObjectURL(file));
    setLogoFile(file); // ✅ INI YANG BENAR
  };

  return (
    <div className="space-y-4 text-gray-700">
      {/* Logo */}
      <div>
        <label className="font-medium text-sm">Company Logo</label>
        <div className="flex items-center gap-3 mt-1">
          <img
            src={logoPreview || "https://placehold.co/200"}
            className="w-20 h-20 rounded-lg object-cover border"
          />
          <input type="file" accept="image/*" onChange={handleLogoUpload} />
        </div>
      </div>

      {/* Name */}
      <div>
        <label className="font-medium text-sm">Company Name</label>
        <input
          name="name"
          value={form.name}
          onChange={handleChange}
          className="w-full border p-2 rounded-lg"
        />
      </div>

      {/* Phone */}
      <div>
        <label className="font-medium text-sm">Phone Number</label>

        <PhoneInput
          defaultCountry="ID"
          international
          withCountryCallingCode
          value={form.phone}
          onChange={handlePhoneChange}
          className="w-full border rounded-lg pl-3 pr-1 py-1 flex flex-col md:flex-row gap-4"
        />
      </div>

      {/* Industry */}
      <div>
        <label className="font-medium text-sm">Industry</label>
        <select
          name="industry_id"
          value={form.industry_id}
          onChange={handleChange}
          className="w-full border p-2 rounded-lg"
        >
          <option value="">Select Industry</option>
          {industries?.map((i) => (
            <option key={i.id} value={i.id}>
              {i.name}
            </option>
          ))}
        </select>
      </div>

      {/* Size */}
      <div>
        <label className="font-medium text-sm">Company Size</label>
        <select
          name="company_size_id"
          value={form.company_size_id}
          onChange={handleChange}
          className="w-full border p-2 rounded-lg"
        >
          <option value="">Select Size</option>
          {sizes?.map((i) => (
            <option key={i.id} value={i.id}>
              {i.name}
            </option>
          ))}
        </select>
      </div>

      {/* Website */}
      <div>
        <label className="font-medium text-sm">Website</label>
        <input
          name="website"
          value={form.website}
          onChange={handleChange}
          className="w-full border p-2 rounded-lg"
        />
      </div>
    </div>
  );
}
